import { AccountType } from '../accounts/singleAccount';

export type SingleBillId = {
	accountId: string;
	billingId: string;
	lines: number;
	billingAccountName: string;
	addBillingType?: string;
	billingAccountType: 'MOBILE_POSTPAID' | 'MOBILE_PREPAID' | 'FIXED' | 'MIXED' | 'INTERNET' | 'UNKNOWN';
	firstAccountType: AccountType;
	accountType: string;
};

const model: types.models.InputModel = {
	accountId: 'accountId',
	billingId: 'billingId',
	lines: 'lines',
	billingAccountName: 'billingAccountName',
	addBillingType: 'addBillingType',
	billingAccountType: 'billingAccountType',
	accountType: 'accountType',
	firstAccountType: 'firstAccountType',
};

export default model;
